import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Package, Calendar, MessageCircle, User } from 'lucide-react';

const tabs = [
  { path: '/customer/dashboard', label: 'Home', icon: Home },
  { path: '/customer/orders', label: 'Orders', icon: Package },
  { path: '/customer/new-order', label: 'New', icon: Calendar },
  { path: '/customer/chat', label: 'Support', icon: MessageCircle },
  { path: '/customer/profile', label: 'Profile', icon: User },
];

const CustomerBottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 md:hidden safe-bottom" data-testid="customer-bottom-nav">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto px-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = pathname === tab.path;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${
                active ? 'text-blue-600' : 'text-slate-400'
              }`}
              data-testid={`bnav-${tab.label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${active ? 'stroke-[2.5]' : ''}`} />
              <span className="text-[10px] font-medium">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default CustomerBottomNav;
